module.exports = {
  // factoryGroup: '工厂集团(Group)',
  // factoryCode: '工厂代码(Factory)',
  // productCode: '商品编码(Product Code)',
  // modelCode: '商品代码(Model Code)',
  // modelName: '商品类型(Model Name)',
  // defectType: 'C品原因(Defect Type)',
  // returnDate: '退货日期(Return Date)',
  // salesOrderCreationDate: '销售单日期(Sales Order Creation Date)',
  // salesOrderSeason: '销售季度(Sales Order Season)',
  // returnOrderId: '退货OMS编码(Return Order ID)',
  // salesOrderId: '销售单号(Sales Order ID)',
  // sku: 'SKU',
  // modelName2: 'Model Name',
  // defectType2: 'Defect Type',
  productThumbnail: 'Product Thumbnail',
  // returnDate2: 'Return Date',
  // factory: 'Factory',
  // factoryGroup2: 'Factory Group',
  // salesOrderCreationDate2: 'Sales Order Creation Date',
  // salesOrderSeason2: 'Sales Order Season',
  // returnOrderId2: 'Return Order ID',
  // salesOrderId2: 'Sales Order ID',
  // exceptionType: 'Exception Type',
  // trackingNo: 'Tracking No'
  productCode: 'Product Code(SKU)',
  model: 'Model',
  defectiveReason: 'Defective Reason',
  factoryGroup: 'Factory Group',

  vendorCd: 'Vendor CD',
  mco: 'MCO',
  returnDate: 'Return Date',
  salesOrderDate: 'Sales Order Date',
  salesOrderSeason: 'Sales Order Season',
  gcCategory: 'GC Category',
  styleCode: 'Style Code',

  salesOrderNumber: 'Sales Order Number',
  select: 'Select',
  enter: 'Enter',
  startDate: 'Start Date',
  endDate: 'End Date',
  search: 'Search',
  reset: 'Reset',
  selectAll: 'ALL',
  last7: 'Last 7 Days',
  last30: 'Last 30 Days',
  last90: 'Last 90 Days',
  queryError: 'Query failed, please try again later',
  retake: 'Retake',
  noData: 'No Data'
}
